import { Headline } from 'components/Headline';

import { Item } from './components/Item';
import { ItemType } from './types';

type ZoneListProps = {
  items: ItemType[];
};

const defaultProps: Partial<ZoneListProps> = {};

export function ZoneList(props: ZoneListProps): React.ReactElement {
  const { items } = { ...defaultProps, ...props };

  const itemsMapped = items?.map((item: ItemType) => (
    <Item key={item.code} name={item.code} />
  ));

  return (
    <div>
      <Headline>Zone</Headline>

      {itemsMapped}
    </div>
  );
}
